import React from 'react';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';

export interface HideUnhideButtonProps {
    hidden: boolean;
    onClick: () => void;
    hideTootip: string;
    showTooltip: string;
}

export function HideUnhideButton(props: HideUnhideButtonProps) {
    const { hidden, showTooltip, hideTootip, onClick } = props;

    const handleOnClick = (e: React.MouseEvent) => {
        onClick();
        e.stopPropagation();
        return true;
    };
    return (
        <div className="HideUnhideButton">
            <ToolbarIcon
                name={hidden ? 'unhide' : 'hide'}
                tooltip={hidden ? showTooltip : hideTootip}
                onClick={handleOnClick}
            />
        </div>
    );
}
